import clickToCall from './clickToVoiceCall';

export default clickToCall;
